module.exports = __webpack_public_path__ + "static/media/about-bg-2.a18976bf.png";